import { render } from "./index.vue?vue&type=template&id=a0fd5576&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts&setup=true&name=search"
export * from "./index.vue?vue&type=script&lang=ts&setup=true&name=search"

import "./index.vue?vue&type=style&index=0&id=a0fd5576&lang=less&scoped=true"
import "@/style/manga-list.less?vue&type=style&index=1&id=a0fd5576&scoped=true&lang=less"
import "@/style/chapter-list.less?vue&type=style&index=2&id=a0fd5576&scoped=true&lang=less"

import exportComponent from "/home/runner/work/smanga/smanga/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0fd5576"],['__file',"src/views/search/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a0fd5576"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a0fd5576', __exports__)) {
    console.log('reload')
    api.reload('a0fd5576', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=a0fd5576&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('a0fd5576', render)
  })

}


export default __exports__